export default "__VITE_ASSET__Gv83PWGO__"